import { Loader } from '@/modules/base/classes/loaders'
import { Result } from '@/modules/errorHandling/results'

export enum StationType {
  Hardware = 'hardware',
  Cloud = 'cloud'
}

class StationBase {
  type: StationType
  name: string
  team_id: string
  info: string
  deleted: boolean
  cefappliance: null|string

  constructor (data: unknown) {
    this.type = StationType.Cloud
    this.name = Loader.loadString(data, 'name')
    this.team_id = Loader.loadString(data, 'team_id')
    this.info = Loader.loadString(data, 'info')
    this.deleted = Loader.loadBoolean(data, 'deleted', false)
    this.cefappliance = Loader.loadStringOrNull(data, 'cefappliance', null)
  }
}

export class StationHardware extends StationBase {
  override type: StationType.Hardware

  constructor (data: unknown) {
    super(data)
    this.type = StationType.Hardware
  }
}

export class StationCloud extends StationBase {
  override type: StationType.Cloud

  constructor (data: unknown) {
    super(data)
    this.type = StationType.Cloud
  }
}

export type Station = StationCloud | StationHardware
export const Station = {
  load: (data: unknown): Result<Station, 'invalid params'|'unknown'> => {
    if (!(data instanceof Object)) {
      return Result.fail('invalid params', 'Could not load Station, data is not an object')
    }
    if (!('type' in data)) return Result.fail('invalid params', 'Could not load Station, missing type')
    try {
      // eslint-disable-next-line dot-notation
      switch (data['type']) {
        case StationType.Cloud:
          return Result.success(new StationCloud(data))
        case StationType.Hardware:
          return Result.success(new StationHardware(data))
        default:
          // eslint-disable-next-line dot-notation
          const message = `Could not load Station, type is not a known station type ${data['type']}`
          return Result.fail('invalid params', message)
      }
    } catch (error) {
      if (error instanceof Error) {
        return Result.fail('invalid params', error.message)
      }
      return Result.fail('unknown', `Unknown error in loadStation ${error}`)
    }
  }
}

